"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemBaseStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _menuTheme = require("./menuTheme");
/**
 * Handles the most basic styling of a menu item:
 *  - how it sits in its container
 *  - colors
 *  - padding/margins
 *  - focus states
 *  - hover states
 *  - disabled states
 *  - etc.
 *
 * To provide maximum flexibility, this component should NOT add styles around
 * how its contents are laid out or the spacing between any of them.
 *
 */
const MenuItemBaseStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("button")(_ref => {
  let {
    themeMode,
    isDisabled,
    layout
  } = _ref;
  return `
            background-color: ${_menuTheme.menuTheme.backgroundColor.rest(themeMode)};
            // min-height to allow growing for metadata items, or other customizations.
            min-height: ${_menuTheme.menuTheme.optionHeight[layout](themeMode)}px;
            border: 0;
            margin: 0 ${layout === "dense" ? `0` : _spacing.sizes.xSmall}px;
            padding: 0 ${layout === "dense" ? _spacing.sizes.small : _spacing.sizes.xSmall}px;
            text-align: left;
            font-weight: 500;
            color: ${_menuTheme.menuTheme.fontColor.rest(themeMode)};
            border-radius: ${layout === "dense" ? `0` : _menuTheme.menuTheme.borderRadius(themeMode)};
            transition: ${_menuTheme.menuTheme.motion.itemBackground(themeMode)};

            &:hover,
            &[aria-expanded="true"] {
                background-color: ${_menuTheme.menuTheme.backgroundColor.hover(themeMode)};
                color: ${_menuTheme.menuTheme.fontColor.hover(themeMode)};
            }

            &:active {
                background-color: ${_menuTheme.menuTheme.backgroundColor.pressed(themeMode)};
                color: ${_menuTheme.menuTheme.fontColor.focus(themeMode)};
            }

            ${isDisabled ? `
                color: ${_menuTheme.menuTheme.fontColor.disabled(themeMode)};

                &:hover {
                    background-color: transparent;                    
                    color: ${_menuTheme.menuTheme.fontColor.disabled(themeMode)};
                    transition: none;
                }

                &:focus {
                    font-weight: 500;
                    color: ${_menuTheme.menuTheme.fontColor.disabled(themeMode)};
                }
            ` : ``}

            &[aria-disabled="true"] {
                cursor: not-allowed;
            }

            // assists in rendering reasonably laid-out children.
            display: flex;
            flex-direction: row;
            align-items: center;

            // Reset ua stylesheet.
            font-family: inherit;
            font-size: ${_menuTheme.menuTheme.fontSize(themeMode)};
            cursor: pointer;

            // For the highlight ::after position: absolute.
            position: relative;

            ${(0, _createFocusRingStyles.createFocusRingStyles)({
    gap: 0,
    componentRadius: 4,
    theme: themeMode,
    componentBorderWidth: 0
  })}

            ::before {
                z-index: 2;
            }

            & > * {
                z-index: 2;
                // To allow the z-index to compare against the absolute ::before.
                position: relative;
            }
        `;
}));
exports.MenuItemBaseStyled = MenuItemBaseStyled;
MenuItemBaseStyled.displayName = "MenuItemBaseStyled";
//# sourceMappingURL=MenuItemBaseStyled.js.map